export default __webpack_public_path__ + "static/media/newstar-logo.2535d3bb.webp";